import React, {Component} from 'react';
import {Tabs, Tab, Table, Button, Image, Card, Row, Col} from 'react-bootstrap';
import {withRouter} from 'react-router-dom';
import '../Common/Common.css';
import ReactPaginate from 'react-paginate';
import NormalOrdersView from './NormalOrdersView';
import ViewNormalOrders from './ViewNormalOrders';
import CreateInvoice from './CreateInvoice';
import StatusNormalOrders from './StatusNormalOrders';
import {DropdownButton, OverlayTrigger, Tooltip} from 'react-bootstrap';

var dateFormat = require('dateformat');

class NormalOrders extends Component {
  constructor(props) {
    super(props);
    this.props = props;

    this.state = {
      key: 'new',
      showNormalOrdersModal: false,
      showViewNormalOrdersModal: false,
      showNormalOrderStatusModel: false,
      newOrderpage: 0,
      newOrderperpage: 10,
      processedOrderspage: 0,
      processedOrdersperpage: 10,
      deliveredOrderspage: 0,
      deliveredOrdersperpage: 10,
      cancelledOrderspage: 0,
      cancelledOrdersperpage: 10,

      searchnormalnew: '',
      searchnormalprogress: '',
      srchComplete: '',
      srchCancel: '',

      filternormalnew: '',
      filternormalprogress: '',
      filternormalcomplete: '',
      filternormalcancel: '',

      showInvoiceModal: false,
    };
  }

  componentDidMount() {
    this.props.fetchNormalOrders({
      page: undefined,
      searchKey: this.state.searchnormalnew,
      filter: this.state.filternormalnew,
    });

    this.props.inprogressOrders({
      page: undefined,
      searchKey: this.state.searchnormalprogress,
      filter: this.state.filternormalprogress,
    });

    this.props.deliveredOrders({
      page: undefined,
      searchKey: this.state.srchComplete,
      filter: this.state.filternormalcomplete,
    });
    this.props.cancelledOrders({
      page: undefined,
      searchKey: this.state.srchCancel,
      filter: this.state.filternormalcancel,
    });
    this.props.fetchNormalorderdlryStatus();
    this.setState({
      ...this.state,
      key:
        (this.props.location && this.props.location.activeTab) ||
        this.state.key,
    });
  }

  handleNormalOrderStatus = item => {
    this.setState({
      showNormalOrderStatusModel: true,
      NormalOrderStatusList: item,
    });
  };
  closeNormalOrderStatusModel = () => {
    this.setState({
      showNormalOrderStatusModel: false,
    });
  };

  showNormalOrdersDetail = item => {
    this.setState(
      {
        ...this.state,
        showNormalOrdersModal: true,
        NormalordersToShow: item,
      },
      () => {
        this.props.ChemistNormalOrdersview({
          item: this.state.NormalordersToShow,
          page: undefined,
        });
      }
    );
  };

  closeNormalOrdersDetailModal = () => {
    this.setState({
      ...this.state,
      showNormalOrdersModal: false,
    });
  };

  showViewNormalOrders = item => {
    this.setState(
      {
        ...this.state,
        showViewNormalOrdersModal: true,
        NormalViewordersToShow: item,
      },
      () => {
        this.props.ChemistNormalOrdersview({
          item: this.state.NormalViewordersToShow,
          page: undefined,
        });
      }
    );
  };

  closeViewNormalOrders = () => {
    this.setState({
      showViewNormalOrdersModal: false,
    });
  };

  InvoiceModal = item => {
    this.setState({
      showInvoiceModal: true,
      InvoiceDetails: item,
    });
    this.props.Totalitemretrieval(item);
  };

  closeInvoiceModal = () => {
    this.setState({
      showInvoiceModal: false,
    });
  };

  handlenewPageClick = e => {
    const selectednewPage = e.selected;
    this.props.newpageSelected({
      page: selectednewPage + 1,
      searchKey: this.state.searchnormalnew,
      filter: this.state.filternormalnew,
    });
    this.setState({newOrderpage: selectednewPage});
  };

  resetnewPage = () => {
    this.setState({newOrderpage: 0});
  };

  handleprogressPageClick = e => {
    const selectedprogressPage = e.selected;
    this.props.progresspageSelected({
      page: selectedprogressPage + 1,
      searchKey: this.state.searchnormalprogress,
      filter: this.state.filternormalprogress,
    });
    this.setState({processedOrderspage: selectedprogressPage});
  };

  resetprogressPage = () => {
    this.setState({processedOrderspage: 0});
  };

  handledeliveredPageClick = e => {
    const selecteddeliveredPage = e.selected;
    this.props.deliveredpageSelected({
      page: selecteddeliveredPage + 1,
      searchKey: this.state.srchComplete,
      filter: this.state.filternormalcomplete,
    });
    this.setState({deliveredOrderspage: selecteddeliveredPage});
  };

  resetdeliveredPage = () => {
    this.setState({deliveredOrderspage: 0});
  };

  handlecancelledPageClick = e => {
    const selectedcancelledPage = e.selected;
    this.props.cancelledpageSelected({
      page: selectedcancelledPage + 1,
      searchKey: this.state.srchCancel,
      filter: this.state.filternormalcancel,
    });
    this.setState({cancelledOrderspage: selectedcancelledPage});
  };

  resetcancelledPage = () => {
    this.setState({cancelledOrderspage: 0});
  };

  newonChange = ev => {
    let name = ev.target.name;
    let val = ev.target.value;

    if (name === 'srchNw') {
      this.setState(
        {
          ...this.state,
          newOrderpage: 0,
          searchnormalnew: val,
          filternormalnew: '',
        },
        () => {
          this.props.fetchNormalOrders({
            page: undefined,
            searchKey: this.state.searchnormalnew,
            filter: this.state.filternormalnew,
          });
        }
      );
    } else if (name === 'srchprogress') {
      this.setState(
        {
          ...this.state,
          processedOrderspage: 0,
          searchnormalprogress: val,
          filternormalprogress: '',
        },
        () => {
          this.props.inprogressOrders({
            page: undefined,
            searchKey: this.state.searchnormalprogress,
            filter: this.state.filternormalprogress,
          });
        }
      );
    } else if (name === 'srchcomplete') {
      this.setState(
        {
          ...this.state,
          deliveredOrderspage: 0,
          srchComplete: val,
          filternormalcomplete: '',
        },
        () => {
          this.props.deliveredOrders({
            page: undefined,
            searchKey: this.state.srchComplete,
            filter: this.state.filternormalcomplete,
          });
        }
      );
    } else if (name === 'srchcancel') {
      this.setState(
        {
          ...this.state,
          cancelledOrderspage: 0,
          srchCancel: val,
          filternormalcancel: '',
        },
        () => {
          this.props.cancelledOrders({
            page: undefined,
            searchKey: this.state.srchCancel,
            filter: this.state.filternormalcancel,
          });
        }
      );
    }
  };

  filternormalChange = ev => {
    let filtername = ev.target.name;
    let filterval = ev.target.value;

    if (filtername === 'newfilter') {
      this.setState(
        {
          ...this.state,
          newOrderpage: 0,
          filternormalnew: filterval,
          searchnormalnew: '',
        },
        () => {
          this.props.fetchNormalOrders({
            page: undefined,
            searchKey: this.state.searchnormalnew,
            filter: this.state.filternormalnew,
          });
        }
      );
    } else if (filtername === 'progressfilter') {
      this.setState(
        {
          ...this.state,
          processedOrderspage: 0,
          filternormalprogress: filterval,
          searchnormalprogress: '',
        },
        () => {
          this.props.inprogressOrders({
            page: undefined,
            searchKey: this.state.searchnormalprogress,
            filter: this.state.filternormalprogress,
          });
        }
      );
    } else if (filtername === 'completefilter') {
      this.setState(
        {
          ...this.state,
          deliveredOrderspage: 0,
          filternormalcomplete: filterval,
          srchComplete: '',
        },
        () => {
          this.props.deliveredOrders({
            page: undefined,
            searchKey: this.state.srchComplete,
            filter: this.state.filternormalcomplete,
          });
        }
      );
    } else if (filtername === 'cancelfilter') {
      this.setState(
        {
          ...this.state,
          cancelledOrderspage: 0,
          filternormalcancel: filterval,
          srchCancel: '',
        },
        () => {
          this.props.cancelledOrders({
            page: undefined,
            searchKey: this.state.srchCancel,
            filter: this.state.filternormalcancel,
          });
        }
      );
    }
  };

  renderTooltip = props =>
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>;

  shipmentTooltip = props =>
    <Tooltip id="button-tooltip" {...props}>
      Ready for shipment
    </Tooltip>;

  addinvoiceTooltip = props =>
    <Tooltip id="button-tooltip" {...props}>
      Upload Invoice
    </Tooltip>;

  render() {
    const newOrdercount = this.props.newOrdersListCount;
    let p1 = this.state.newOrderpage + 1;

    let newOrdersPageCount = Math.ceil(
      newOrdercount / this.state.newOrderperpage
    );

    const processedOrderscount = this.props.processedOrdersListCount;
    let p2 = this.state.processedOrderspage + 1;
    let processedOrdersPageCount = Math.ceil(
      processedOrderscount / this.state.processedOrdersperpage
    );

    const deliveredOrdercount = this.props.deliveredOrdersListCount;
    let p3 = this.state.deliveredOrderspage + 1;
    let deliveredOrdersPageCount = Math.ceil(
      deliveredOrdercount / this.state.deliveredOrdersperpage
    );

    const cancelledOrderscount = this.props.cancelledOrdersListCount;
    let p4 = this.state.cancelledOrderspage + 1;
    let cancelledOrdersPageCount = Math.ceil(
      cancelledOrderscount / this.state.cancelledOrdersperpage
    );

    const {
      newOrdersList,
      newOrdersListCount,
      processedOrdersList,
      processedOrdersListCount,
      deliveredOrdersList,
      deliveredOrdersListCount,
      cancelledOrdersList,
      cancelledOrdersListCount,
      normalOrderDtls,
      normalOrderDtlsCount,
      NormalOrderEdit,
      NormalOrderReject,
      changePaymentstatusnormal,
      completeitemDetails,
      completeitemDetailsCount,
      manualInvoice,
      itempageSelected,
      itemViewpageSelected,
      count,
      viewcount,
    } = this.props;

    const {
      key,
      searchnormalnew,
      searchnormalprogress,
      srchComplete,
      srchCancel,
      filternormalnew,
      filternormalprogress,
      filternormalcomplete,
      filternormalcancel,
      showNormalOrdersModal,
      NormalordersToShow,
      NormalViewordersToShow,
      newOrderpage,
      showViewNormalOrdersModal,
      showInvoiceModal,
      InvoiceDetails,
    } = this.state;

    const {
      newonChange,
      filternormalChange,
      closeNormalOrdersDetailModal,
      resetnewPage,
      handlenewPageClick,
      closeViewNormalOrders,
      resetPage,
      closeInvoiceModal,
      showViewNormalOrders,
      InvoiceModal,
      itemsPageClick,
      itemsViewPageClick,
    } = this;

    return (
      <div className="salesreturndiv">
        <Card>
          <div>
            <Tabs
              activeKey={key}
              onSelect={k => {
                this.setState({...this.state, key: k});
              }}
            >
              <Tab className="orderTab" eventKey="new" title="New">
                <div className="tabsdiv">
                  <Row>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div>
                        <h5 className="tablecardtitle">Normal Orders - New</h5>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="commonInputdiv">
                        <div className="commonInput">
                          <i className="fa fa-search fa-lg cmnSearchIcon" />
                          <input
                            type="text"
                            name="srchNw"
                            placeholder="Order No / Org Name"
                            value={searchnormalnew}
                            onChange={newonChange}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                      style={{visibility: 'hidden'}}
                    >
                      <div className="commonFilterDiv">
                        <select
                          name="newfilter"
                          value={filternormalnew}
                          onChange={filternormalChange}
                          className="commonFilterSelect"
                        >
                          <option value="">All</option>
                          <option value="payNow">Prepaid</option>
                          <option value="payLater">Postpaid</option>
                        </select>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="salescommonRecrd">
                        <i className="cui-note icons cmnRecordIcon" />
                        <span className="cmnPageCount">
                          {newOrdercount === undefined
                            ? 0
                            : <span>
                                {newOrdercount}
                              </span>}
                        </span>
                        <span className="cmnResutText">Results</span>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Table hover responsive className="">
                  <thead className="tablecommonCard">
                    <tr>
                      <th>#</th>
                      <th>Order No</th>
                      <th>Chemist Name</th>
                      <th>Organization Name</th>
                      <th>Payment Mode</th>
                      <th>Created Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {newOrdersList !== undefined &&
                      newOrdersListCount !== 0 &&
                      newOrdersList.map((item, i) =>
                        <tr key={i}>
                          <th scope="row">
                            {10 * (p1 - 1) + i + 1}
                          </th>
                          <td className="cmn_Cap">
                            {item && item.orderNo}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFrom && item.orderFrom.name}{' '}
                            {item && item.orderFrom && item.orderFrom.lName}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFromName}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.payMode}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null &&
                              item.status &&
                              (item.status === 'confirm'
                                ? <span className="badge badge-primary">
                                    Accepted
                                  </span>
                                : <span className="badge badge-primary">
                                    {item.status}
                                  </span>)}
                          </td>

                          <td className="cmnViewIcon">
                            <div
                              style={{
                                marginLeft: '15px',
                              }}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                delay={{show: 250, hide: 400}}
                                overlay={this.renderTooltip}
                              >
                                <i
                                  className="fa fa-eye fa-lg "
                                  onClick={() =>
                                    this.showNormalOrdersDetail({item: item})}
                                />
                              </OverlayTrigger>
                            </div>
                          </td>
                        </tr>
                      )}
                  </tbody>
                </Table>

                <NormalOrdersView
                  show={showNormalOrdersModal}
                  close={closeNormalOrdersDetailModal}
                  NormalordersToShow={NormalordersToShow}
                  normalOrderDtls={normalOrderDtls}
                  normalOrderDtlsCount={normalOrderDtlsCount}
                  NormalOrderEdit={NormalOrderEdit}
                  resetnewPage={resetnewPage}
                  NormalOrderReject={NormalOrderReject}
                  changePaymentstatusnormal={changePaymentstatusnormal}
                  itempageSelected={itempageSelected}
                  itemsPageClick={itemsPageClick}
                  count={count}
                  pdfFullData={this.props.pdfFullData}
                  searchChemistitems={this.props.searchChemistitems}
                  normalOrderSearchList={this.props.normalOrderSearchList}
                  normalOrderSearchCount={this.props.normalOrderSearchCount}
                />
                {newOrdersPageCount > 1
                  ? <div className="paginationDiv">
                      <ReactPaginate
                        forcePage={newOrderpage}
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={newOrdersPageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlenewPageClick}
                        containerClassName={'pagination flex-wrap'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                      />
                    </div>
                  : null}
                {(newOrdersList === undefined || newOrdersListCount === 0) &&
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require('../../assets/img/nodata4.png')}
                      />
                    </div>
                    <div className="noDataTextDiv">No new orders to show!</div>
                  </div>}
              </Tab>

              <Tab
                className="orderTab"
                eventKey="processing"
                title="In Progress"
              >
                <div className="tabsdiv">
                  <Row>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div>
                        <h5 className="tablecardtitle">
                          {' '}Normal Orders - In Progress
                        </h5>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="commonInputdiv">
                        <div className="commonInput">
                          <i className="fa fa-search fa-lg cmnSearchIcon" />
                          <input
                            type="text"
                            name="srchprogress"
                            placeholder="Order No / Org Name"
                            value={searchnormalprogress}
                            onChange={newonChange}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                      style={{visibility: 'hidden'}}
                    >
                      <div className="commonFilterDiv">
                        <select
                          name="progressfilter"
                          value={filternormalprogress}
                          onChange={filternormalChange}
                          className="commonFilterSelect"
                        >
                          <option value="">All</option>
                          <option value="payNow">Prepaid</option>
                          <option value="payLater">Postpaid</option>
                        </select>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="salescommonRecrd">
                        <i className="cui-note icons cmnRecordIcon" />
                        <span className="cmnPageCount">
                          {processedOrderscount === undefined
                            ? 0
                            : <span>
                                {processedOrderscount}
                              </span>}
                        </span>
                        <span className="cmnResutText">Results</span>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Table hover responsive className="">
                  <thead className="tablecommonCard">
                    <tr>
                      <th>#</th>
                      <th>Order No</th>
                      <th>Chemist Name</th>
                      <th>Organization Name</th>
                      <th>Payment Mode</th>
                      <th>Created Date</th>

                      <th>Amount</th>
                      <th>Status</th>

                      <th>Action</th>
                    </tr>
                  </thead>
                  {processedOrdersList !== undefined &&
                    processedOrdersListCount !== 0 &&
                    processedOrdersList.map((item, i) =>
                      <tbody className="tableBody">
                        <tr key={i}>
                          <th scope="row">
                            {10 * (p2 - 1) + i + 1}
                          </th>
                          <td className="cmn_Cap">
                            {item && item.orderNo}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFrom && item.orderFrom.name}{' '}
                            {item && item.orderFrom && item.orderFrom.lName}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFromName}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.payMode}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                              : null}
                          </td>

                          <td className="cmn_Cap">
                            {item !== null && item.hasCreated
                              ? <p>
                                  {item !== null && item.invDtls.amount
                                    ? 'INR ' + item.invDtls.amount
                                    : null}
                                </p>
                              : <div onClick={() => InvoiceModal({item: item})}>
                                  <i
                                    className="nav-icon fa fa-upload"
                                    style={{
                                      fontSize: '15px',
                                      justifyContent: 'center',
                                      display: 'flex',
                                    }}
                                  />
                                  <p className="uploadinvoice">
                                    Upload Invoice{' '}
                                  </p>
                                </div>}
                          </td>

                          <td className="cmn_Cap">
                            {item !== null &&
                            item.status &&
                            (item.hasCreated && item.status === 'accepted')
                              ? <span className="badge badge-warning">
                                  Not paid
                                </span>
                              : <span className="badge badge-success">
                                  {item.status}
                                </span>}
                          </td>
                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                delay={{show: 250, hide: 400}}
                                overlay={this.renderTooltip}
                              >
                                <i
                                  className="fa fa-eye fa-lg "
                                  onClick={() =>
                                    this.showNormalOrdersDetail({item: item})}
                                />
                              </OverlayTrigger>

                              {item !== null &&
                              ((item.payType === 'payNow' &&
                                item.invDtls &&
                                item.invDtls.status === 'paid') ||
                                (item.hasCreated &&
                                  item.status === 'accepted' &&
                                  item.payType === 'payLater') ||
                                (item.payType === 'payLater' &&
                                  item.invDtls &&
                                  item.invDtls.status === 'paid'))
                                ? <OverlayTrigger
                                    placement="bottom"
                                    delay={{show: 250, hide: 400}}
                                    overlay={this.shipmentTooltip}
                                  >
                                    <i
                                      className="nav-icon fa fa-paper-plane"
                                      style={{
                                        paddingLeft: 10,
                                        fontSize: '15px',
                                      }}
                                      onClick={() =>
                                        this.handleNormalOrderStatus({
                                          item: item,
                                        })}
                                    />
                                  </OverlayTrigger>
                                : null}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    )}
                </Table>

                <CreateInvoice
                  show={showInvoiceModal}
                  close={closeInvoiceModal}
                  InvoiceDetails={InvoiceDetails}
                  completeitemDetails={completeitemDetails}
                  completeitemDetailsCount={completeitemDetailsCount}
                  manualInvoice={manualInvoice}
                />

                <StatusNormalOrders
                  showNormalOrderStatusModel={
                    this.state.showNormalOrderStatusModel
                  }
                  closeNormalOrderStatusModel={this.closeNormalOrderStatusModel}
                  normaldlvrystatusList={this.props.normaldlvrystatusList}
                  NormalOrderStatusList={this.state.NormalOrderStatusList}
                  NormalordersShipped={this.props.NormalordersShipped}
                />

                {processedOrdersPageCount > 1
                  ? <div className="paginationDiv">
                      <ReactPaginate
                        forcePage={this.state.processedOrderspage}
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={processedOrdersPageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handleprogressPageClick}
                        containerClassName={'pagination flex-wrap'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                      />
                    </div>
                  : null}
                {(processedOrdersList === undefined ||
                  processedOrdersListCount === 0) &&
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require('../../assets/img/nodata4.png')}
                      />
                    </div>
                    <div className="noDataTextDiv">
                      No processing orders to show!
                    </div>
                  </div>}
              </Tab>

              <Tab className="orderTab" eventKey="complete" title="Completed">
                <div className="tabsdiv">
                  <Row>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div>
                        <h5 className="tablecardtitle">
                          Normal Orders - Completed
                        </h5>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="commonInputdiv">
                        <div className="commonInput">
                          <i className="fa fa-search fa-lg cmnSearchIcon" />
                          <input
                            type="text"
                            name="srchcomplete"
                            placeholder="Order No / Org Name"
                            value={srchComplete}
                            onChange={newonChange}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                      style={{visibility: 'hidden'}}
                    >
                      <div className="commonFilterDiv">
                        <select
                          name="completefilter"
                          value={filternormalcomplete}
                          onChange={filternormalChange}
                          className="commonFilterSelect"
                        >
                          <option value="">All</option>
                          <option value="payNow">Prepaid</option>
                          <option value="payLater">Postpaid</option>
                        </select>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="salescommonRecrd">
                        <i className="cui-note icons cmnRecordIcon" />
                        <span className="cmnPageCount">
                          {deliveredOrdercount === undefined
                            ? 0
                            : <span>
                                {deliveredOrdercount}
                              </span>}
                        </span>
                        <span className="cmnResutText">Results</span>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Table hover responsive className="">
                  <thead className="tablecommonCard">
                    <tr>
                      <th>#</th>
                      <th>Order No</th>
                      <th>Chemist Name</th>
                      <th>Organization Name</th>

                      <th>Created Date</th>
                      <th>Amount</th>
                      <th>Payment Status</th>
                      <th>Order Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {deliveredOrdersList !== undefined &&
                    deliveredOrdersListCount !== 0 &&
                    deliveredOrdersList.map((item, i) =>
                      <tbody className="tableBody">
                        <tr key={i}>
                          <th scope="row">
                            {10 * (p3 - 1) + i + 1}
                          </th>
                          <td className="cmn_Cap">
                            {item && item.orderNo}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFrom && item.orderFrom.name}{' '}
                            {item && item.orderFrom && item.orderFrom.lName}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFromName}
                          </td>

                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.invDtls.amount
                              ? 'INR ' + item.invDtls.amount
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null &&
                            item.invDtls.status &&
                            item.invDtls.status === 'open'
                              ? <span className="badge badge-danger">
                                  Not Paid
                                </span>
                              : <span className="badge badge-success">
                                  {item.invDtls.status}
                                </span>}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null &&
                            item.status &&
                            item.status === 'shipmentReady'
                              ? <span className="badge badge-warning">
                                  Dispatched
                                </span>
                              : <span className="badge badge-success">
                                  {item.status}
                                </span>}
                          </td>
                          <td className="cmnViewIcon">
                            <div
                              style={{
                                marginLeft: '15px',
                              }}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                delay={{show: 250, hide: 400}}
                                overlay={this.renderTooltip}
                              >
                                <i
                                  className="fa fa-eye fa-lg "
                                  onClick={() =>
                                    this.showNormalOrdersDetail({item: item})}
                                />
                              </OverlayTrigger>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    )}
                </Table>

                {deliveredOrdersPageCount > 1
                  ? <div className="paginationDiv">
                      <ReactPaginate
                        forcePage={this.state.deliveredOrderspage}
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={deliveredOrdersPageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handledeliveredPageClick}
                        containerClassName={'pagination flex-wrap'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                      />
                    </div>
                  : null}
                {(deliveredOrdersList === undefined ||
                  deliveredOrdersListCount === 0) &&
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require('../../assets/img/nodata4.png')}
                      />
                    </div>
                    <div className="noDataTextDiv">
                      No completed orders to show!
                    </div>
                  </div>}
              </Tab>

              <Tab className="orderTab" eventKey="cancel" title="Cancelled">
                <div className="tabsdiv">
                  <Row>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div>
                        <h5 className="tablecardtitle">
                          {' '}Normal Orders - Cancelled
                        </h5>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="commonInputdiv">
                        <div className="commonInput">
                          <i className="fa fa-search fa-lg cmnSearchIcon" />
                          <input
                            type="text"
                            name="srchcancel"
                            placeholder="Order No / Org Name"
                            value={srchCancel}
                            onChange={newonChange}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                      style={{visibility: 'hidden'}}
                    >
                      <div className="commonFilterDiv">
                        <select
                          name="cancelfilter"
                          value={filternormalcancel}
                          onChange={filternormalChange}
                          className="commonFilterSelect"
                        >
                          <option value="">All</option>
                          <option value="payNow">Prepaid</option>
                          <option value="payLater">Postpaid</option>
                        </select>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="salescommonRecrd">
                        <i className="cui-note icons cmnRecordIcon" />
                        <span className="cmnPageCount">
                          {cancelledOrderscount === undefined
                            ? 0
                            : <span>
                                {cancelledOrderscount}
                              </span>}
                        </span>
                        <span className="cmnResutText">Results</span>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Table hover responsive className="">
                  <thead className="tablecommonCard">
                    <tr>
                      <th>#</th>
                      <th>Order No</th>
                      <th>Chemist Name</th>
                      <th>Organization Name</th>
                      <th>Payment Mode</th>
                      <th>Created Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {cancelledOrdersList !== undefined &&
                    cancelledOrdersListCount !== 0 &&
                    cancelledOrdersList.map((item, i) =>
                      <tbody className="tableBody">
                        <tr key={i}>
                          <th scope="row">
                            {10 * (p4 - 1) + i + 1}
                          </th>
                          <td className="cmn_Cap">
                            {item && item.orderNo}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFrom && item.orderFrom.name}{' '}
                            {item && item.orderFrom && item.orderFrom.lName}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.orderFromName}
                          </td>
                          <td className="cmn_Cap">
                            {item && item.payMode}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            <span className="badge badge-danger">
                              {item && item.status}
                            </span>
                          </td>
                          <td className="cmnViewIcon">
                            <div
                              style={{
                                marginLeft: '15px',
                              }}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                delay={{show: 250, hide: 400}}
                                overlay={this.renderTooltip}
                              >
                                <i
                                  className="fa fa-eye fa-lg "
                                  onClick={() =>
                                    this.showNormalOrdersDetail({item: item})}
                                />
                              </OverlayTrigger>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    )}
                </Table>

                {cancelledOrdersPageCount > 1
                  ? <div className="paginationDiv">
                      <ReactPaginate
                        forcePage={this.state.cancelledOrderspage}
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={cancelledOrdersPageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlecancelledPageClick}
                        containerClassName={'pagination flex-wrap'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                      />
                    </div>
                  : null}
                {(cancelledOrdersList === undefined ||
                  cancelledOrdersListCount === 0) &&
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require('../../assets/img/nodata4.png')}
                      />
                    </div>
                    <div className="noDataTextDiv">
                      No cancelled orders to show!
                    </div>
                  </div>}
              </Tab>
            </Tabs>
          </div>
        </Card>
      </div>
    );
  }
}

export default withRouter(NormalOrders);
